import React from "react";

// Memorial mourning ribbon — real black-satin photo, background cut to transparency.
// A gold/white rim glow keeps the black ribbon legible against the dark navy backdrop.
export default function MemorialRibbon({ size = 84 }) {
  return (
    <span style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
      {/* faint radial 'reading plate' to lift the ribbon off the dark background */}
      <span
        aria-hidden
        style={{
          position: "absolute",
          width: size * 2.0,
          height: size * 2.0,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(64,70,86,0.55) 0%, rgba(40,45,58,0.26) 46%, rgba(22,26,36,0) 72%)",
          pointerEvents: "none",
        }}
      />
      <img
        src="/brand/black_ribbon_cut.png"
        alt="Memorial mourning ribbon"
        style={{
          position: "relative",
          width: size,
          height: "auto",
          display: "block",
          filter:
            "drop-shadow(0 0 1px rgba(255,255,255,0.9)) drop-shadow(0 0 7px rgba(201,162,75,0.6)) drop-shadow(0 2px 5px rgba(0,0,0,0.7))",
        }}
      />
    </span>
  );
}
